import { on, createReducer } from '@ngrx/store';

import type { RbacPermissionsEntity } from './rbac-permissions.model';
import RbacPermissionsActions from './rbac-permissions.actions';

export const RBAC_PERMISSIONS_FEATURE_KEY = 'rbacPermissions';

export type RbacPermissionsState = {
    permissions: RbacPermissionsEntity;
    loaded: boolean;
    error?: string;
};

export const initialRbacPermissionsState: RbacPermissionsState = {
    permissions: null,
    loaded: false,
    error: null,
};

export const rbacPermissionsReducer = createReducer<RbacPermissionsState>(
    initialRbacPermissionsState,
    on(RbacPermissionsActions.loadRbacPermissionsSuccess, (state: RbacPermissionsState, { permissions }) => ({
        ...state,
        permissions,
        loaded: true,
    })),
    on(RbacPermissionsActions.loadRbacPermissionsFailure, (state: RbacPermissionsState, { error }) => ({
        ...state,
        loaded: true,
        error,
    }))
);
